import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { GetDemoFormComponent } from 'src/app/components/layout/get-demo-form/get-demo-form.component';
import { InViewportDirective } from 'src/app/directives/in-viewport.directive';

@Component({
    selector: 'tsg-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
      imports: [GetDemoFormComponent, CommonModule, InViewportDirective], 
    standalone: true,
})
export class HomeComponent {
  constructor(public auth: AuthService) {}
  onCardEnter() {
    document.querySelector('.card-overlay')?.classList.add('card-overlay-animation');
  }

  onCardExit() {
    document.querySelector('.card-overlay')?.classList.remove('card-overlay-animation');
  }

  onIconEnter(icon: string) {
    const el = document.querySelector(`.${icon}`);
    console.log(el)
    el?.classList.add('icon-animation');
  }

  onIconExit(icon: string) {
    const el = document.querySelector(`.${icon}`);
    el?.classList.remove('icon-animation');
  }
  
  toggleDemoButton(isDark: boolean) {
    const el = document.querySelector('.button.nav-cta');
    if (!el) return;

    el.classList.remove('button-dark', 'button-light');
    el.classList.add(isDark ? 'button-light' : 'button-dark');
  }

}
